import { Box, Center, HStack, Text } from "@chakra-ui/react";
import { OrderStatus } from "lib/api/enum";
import { ShippingAddressModel } from "lib/api/model";
import {
    convertDateReservationDot,
    convertDateYYYYMMDDFDot,
    onRegexValidationPhone,
} from "lib/utils/regular";
import SubTitle from "./SubTitle";

interface ButlerInfoProps {
    orderStatus: OrderStatus;
    butlerAddressData?: ShippingAddressModel | null;
}

const ButlerInfo = (props: ButlerInfoProps) => {
    const { orderStatus, butlerAddressData } = props;
    const subLabel = () => {
        if (orderStatus <= OrderStatus.MINTING) {
            return "픽업내역";
        } else {
            return "배송내역";
        }
    };

    if (!butlerAddressData) {
        return (
            <Center
                h="2.5rem"
                fontSize="0.813rem"
                fontWeight={"semibold"}
                border="1px"
                borderRadius={"sm"}
                borderColor="#eeeeee"
                bgColor={"#fafafa"}
            >
                배송을 준비 중입니다.
            </Center>
        );
    }

    return (
        <Box>
            <SubTitle>픽업/배송 정보</SubTitle>
            <Text fontSize="0.813rem" fontWeight={"semibold"} mb="0.625rem">
                {subLabel()}
            </Text>
            <HStack fontSize="0.813rem" fontWeight={"medium"} mb="0.375rem">
                <Text w="5.125rem" color="#757575">
                    방식
                </Text>
                <Text color="#212121">{"예약픽업・배송"}</Text>
                {/* <Center
                    fontSize="0.6875rem"
                    fontWeight={"semibold"}
                    color="white"
                    bgColor={
                        butlerAddressData?.untact_yn === 0
                            ? "mint.500"
                            : "black"
                    }
                    px="0.25rem"
                    py="0.1875rem"
                    borderRadius={"md"}
                >
                    {butlerAddressData?.untact_yn === 0 ? "대면" : "비대면"}
                </Center> */}
            </HStack>
            <HStack
                fontSize="0.813rem"
                fontWeight={"medium"}
                mb="0.5rem"
                alignItems={"flex-start"}
            >
                <Text w="5.125rem" color="#757575">
                    예약내용
                </Text>
                <Box>
                    {/* <Text color="#212121">
                        {`${convertDateReservationDot(
                            butlerAddressData?.reservation_date!
                        )} ${
                            orderStatus <= OrderStatus.MINTING
                                ? "픽업예정"
                                : "배송예정"
                        }`}
                    </Text> */}
                    {butlerAddressData?.complete_date! && (
                        <Text>{`${convertDateYYYYMMDDFDot(
                            butlerAddressData?.complete_date!
                        )} ${
                            orderStatus <= OrderStatus.MINTING
                                ? "픽업완료"
                                : "배송완료"
                        }`}</Text>
                    )}
                    {(orderStatus === OrderStatus.CANCEL_ORDER ||
                        orderStatus === OrderStatus.REJECT_ORDER) && (
                        <Text color="#fc375f">주문취소</Text>
                    )}
                </Box>
            </HStack>
            <HStack fontSize="0.813rem" fontWeight={"medium"} mb="0.5rem">
                <Text w="5.125rem" color="#757575">
                    이름
                </Text>
                <Text color="#212121">{butlerAddressData?.address_name}</Text>
            </HStack>
            <HStack fontSize="0.813rem" fontWeight={"medium"} mb="0.5rem">
                <Text w="5.125rem" color="#757575">
                    연락처
                </Text>
                <Text color="#212121">
                    {onRegexValidationPhone(butlerAddressData?.address_phone!)}
                </Text>
            </HStack>
            <HStack
                fontSize="0.813rem"
                fontWeight={"medium"}
                mb="0.5rem"
                alignItems={"flex-start"}
            >
                <Text w="5.125rem" color="#757575">
                    주소
                </Text>
                <Text
                    flex="1"
                    color="#212121"
                    whiteSpace={"pre-wrap"}
                    wordBreak="break-word"
                >
                    {`${butlerAddressData?.address} ${butlerAddressData?.address_detail}`}
                </Text>
            </HStack>
            <HStack
                fontSize="0.813rem"
                fontWeight={"medium"}
                mb="0.5rem"
                alignItems={"flex-start"}
            >
                <Text w="5.125rem" color="#757575">
                    요청사항
                </Text>
                <Text
                    flex="1"
                    color="#212121"
                    whiteSpace={"pre-wrap"}
                    wordBreak="break-word"
                >
                    {butlerAddressData?.comment}
                </Text>
            </HStack>
        </Box>
    );
};

export default ButlerInfo;
